module.exports = __webpack_public_path__ + "img/placard_m_03.8a93860b.png";